export const SET_LIST_SERVICE = '@@LIST_SERVICE/SET_LIST_SERVICE';
export const SET_IS_LOADING = '@@LIST_SERVICE/SET_IS_LOADING';
